/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import { agentManager } from '@/api/ajax';
const nowDate = new Date();
nowDate.setDate(nowDate.getDate() - 1);

export default [
  {
    width: 180,
    label: '',
    tip: '项目参与人',
    key: 'userName',
    id: 'userName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '',
    tip: '经营者',
    key: 'userName',
    id: 'operator',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '',
    tip: '个体',
    key: 'userEnterpriseName',
    id: 'userEnterpriseName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '',
    tip: '手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '启用状态',
    tip: '请选择启用状态',
    key: 'status',
    id: 'status',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '全部',
        key: ''
      },
      {
        name: '启用',
        key: 1
      },
      {
        name: '禁用',
        key: 2
      }
    ]
  },
  {
    width: 180,
    tip: '请选择订单类型',
    key: 'invoiceOrderType',
    id: 'invoiceOrderType',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '支付订单',
        key: 1
      },
      {
        name: '综合服务费',
        key: 2
      }
    ]
  },
  {
    width: 180,
    label: '当前交易结构',
    tip: '请选择',
    key: 'taxCollectionPattern',
    id: 'taxCollectionPattern',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '汇总申报',
        key: 1
      },
      {
        name: '委托代开',
        key: 2
      },
      {
        name: '委托代发',
        key: 3
      },
      {
        name: '运营基地',
        key: 4
      },
      {
        name: '委托代开(线上)',
        key: 6
      },
      {
        name: '工具',
        key: 9
      }
    ]
  },
  {
    width: 180,
    label: '',
    tip: '项目名称',
    key: 'projectName',
    id: 'projectName',
    slot: 'input',
    clearable: true
  },
  {
    width: 180,
    label: '',
    tip: '项目方',
    key: 'industryEnterpriseId',
    id: 'industryEnterpriseId',
    clearable: true,
    slot: 'ajaxSelect',
    ajax: agentManager.listIndustryEnterpriseName,
    prop: { label: 'enterpriseName', code: 'id' },
    query: { userType: 1 },
    ajaxQuery: 'industryEnterpriseName'
  },
  {
    width: 180,
    label: '',
    tip: '人员标签',
    key: 'userTag',
    id: 'userTag',
    clearable: true,
    slot: 'ajaxSelect',
    ajax: agentManager.listUserTag,
    prop: { label: 'userTag', code: 'userTag' },
    query: { userType: 1 },
    ajaxQuery: 'userTag'
  },
  {
    width: 180,
    label: '',
    tip: '项目方',
    key: 'industryEnterpriseId',
    id: 'industryEnterpriseIdForGeti',
    clearable: true,
    slot: 'ajaxSelect',
    ajax: agentManager.listIndustryEnterpriseName,
    prop: { label: 'enterpriseName', code: 'id' },
    query: { userType: 2 },
    ajaxQuery: 'industryEnterpriseName'
  },
  {
    width: 180,
    label: '',
    tip: '人员标签',
    key: 'userTag',
    id: 'userTagForGeti',
    clearable: true,
    slot: 'ajaxSelect',
    ajax: agentManager.listUserTag,
    prop: { label: 'userTag', code: 'userTag' },
    query: { userType: 2 },
    ajaxQuery: 'userTag'
  },
  {
    width: 180,
    label: '',
    tip: '实名认证状态',
    key: 'authStatus',
    id: 'authStatus',
    slot: 'select',
    clearable: true,
    options: [
      { name: '未认证', key: 0 },
      { name: '认证成功', key: 1 },
      { name: '认证失败', key: 2 }
    ]
  },
  {
    width: 180,
    label: '',
    tip: '项目执行状态',
    key: 'isComplete',
    id: 'isComplete',
    slot: 'select',
    clearable: true,
    options: [
      { name: '执行中', key: 0 },
      { name: '已完结', key: 1 }
    ]
  },
  {
    width: 180,
    label: '',
    tip: '入驻状态',
    key: 'settledStatus',
    id: 'settledStatus',
    slot: 'select',
    clearable: true,
    options: [
      { name: '未入驻', key: 0 },
      { name: '已入驻', key: 1 },
      { name: '已退出', key: 2 }
    ]
  },
  {
    width: 180,
    label: '',
    tip: '项目是否停用',
    key: 'agentStatus',
    id: 'agentStatus',
    slot: 'select',
    clearable: true,
    options: [
      { name: '否', key: 1 },
      { name: '是', key: 2 }
    ]
  },
  {
    width: 180,
    label: '',
    tip: '预计结算日期',
    key: 'estimateSettlementTime',
    id: 'estimateSettlementTime',
    slot: 'date',
    type: 'date',
    valueFormat: 'yyyy-MM-dd',
    clearable: true,
    pickerOptions: {
      disabledDate(time) {
        return time < nowDate;
      }
    }
  }
];
